import { FormSection } from '../../DigitalDossier/DigitalDossierSection/components/FormSection';
import { Grid, ReadOnlyField } from '@agrotoken-tech/ui';
import { FormProvider, Stack, useForm, GridItem } from '@agrotoken-tech/ui';
import { useTranslation } from '@bcba/react-hooks';
import { CommonDigitalDossierFormsAndDocsInformationSerializer } from '@bcba/serializers';
import { mapDocumentationAndFormsSerializerToDTO } from '../../DigitalDossier/DigitalDossierSection/DocumentationAndForms/utils';
import { MultipleDocumentSection } from '../../shared/MultipleDocumentSection';
import { DocumentSection } from '../../shared/DocumentSection';

type Props = {
  data: CommonDigitalDossierFormsAndDocsInformationSerializer;
};

export const ReadOnlyDocsAndFormsInfoSection = ({ data }: Props) => {
  const { t } = useTranslation();

  const apiDataMappedToLocalState =
    mapDocumentationAndFormsSerializerToDTO(data);

  const formMethods = useForm({
    defaultValues: apiDataMappedToLocalState,
  });

  return (
    <FormSection title={t('common.documentationAndForms')}>
      <form noValidate>
        <FormProvider {...formMethods}>
          <Stack gap={8}>
            <Grid
              templateColumns={{ sm: 'repeat(1, 1fr)', md: 'repeat(2, 1fr)' }}
              gap={6}
            >
              <DocumentSection
                isDocumentRequired
                documentName="sisaFile"
                label={t('common.pages.docsAndForms.sisaFile.label')}
                hideDelete
                isReadonly
              />
              <DocumentSection
                mt={14}
                documentName="statuteFile"
                isDocumentRequired
                label={t('common.pages.docsAndForms.statuteFile.label')}
                hideDelete
                isReadonly
              />
              <MultipleDocumentSection
                mt={14}
                name="statuteChangeFiles"
                isDocumentRequired
                label={t('common.pages.docsAndForms.statuteChangeFiles.label')}
                additionalLabel={t(
                  'common.pages.docsAndForms.additionalStatuteChangeFiles.label',
                )}
                hideDelete
                isReadonly
              />
              <MultipleDocumentSection
                mt={14}
                name="assemblyBoardMinutesFiles"
                isDocumentRequired
                label={t(
                  'common.pages.docsAndForms.assemblyBoardMinutesFiles.label',
                )}
                additionalLabel={t(
                  'common.pages.docsAndForms.additionalAssemblyBoardMinutesFiles.label',
                )}
                hideDelete
                isReadonly
              />
              <MultipleDocumentSection
                mt={14}
                name="powerOfAttorneyFiles"
                isDocumentRequired
                label={t(
                  'common.pages.docsAndForms.powerOfAttorneyFiles.label',
                )}
                additionalLabel={t(
                  'common.pages.docsAndForms.additionalPowerOfAttorneyFiles.label',
                )}
                hideDelete
                isReadonly
              />
              <ReadOnlyField
                label={t('common.pages.docsAndForms.boxNumber.label')}
                value={data?.fileBoxNumber || t('common.toBeCompletedByBolsa')}
              />
              <MultipleDocumentSection
                mt={14}
                name="additionalDocumentFiles"
                isDocumentRequired
                label={t('common.pages.docsAndForms.additionalDocument.label')}
                additionalLabel={t(
                  'common.pages.docsAndForms.additionalDocument.label',
                )}
                hideDelete
                isReadonly
              />
              <GridItem />
            </Grid>
          </Stack>
        </FormProvider>
      </form>
    </FormSection>
  );
};
